import "./Scenes.css";
import Header from "./Header.js"
import fb from '../media/logo-fb-2.png';
import insta from '../media/logo-insta-2.png';
import spotify from '../media/spotify.png';
import deezer from '../media/deezer.png';

function Scenes() {
return (
    <div id="scenes">
        <div id="headerScenes">
        <div id="imgHeaderScenes">
        </div>
        <Header /></div>

        <div id="contentScenes">
            <p id="scenesTitle">Nos Scenes</p>
            <hr/>
            <p class="scenesSubtitle">Rotonde</p>
            <p>14 - 16 Av. des Arts, 69100 Villeurbanne</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11129.457099481107!2d4.865102294798888!3d45.78392936733119!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4eaa0f05f4601%3A0x17e6fedbb7ea75b3!2sLa%20Rotonde%20INSA%20Lyon!5e0!3m2!1sfr!2sfr!4v1679046859919!5m2!1sfr!2sfr" id="map" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="map"></iframe>
            
            <div class="align-right-scenes">
            <p class="scenesSubtitle">Théâtre Astrée</p>
            <p>6 Av. Gaston Berger, 69100 Villeurbanne</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2782.3878061808186!2d4.86835431541788!3d45.78345787910603!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4eaa180d00f9d%3A0x26d70cd12f080961!2zVGjDqcOidHJlIEFzdHLDqWUgLSBVbml2ZXJzaXTDqSBMeW9uIDE!5e0!3m2!1sfr!2sfr!4v1679047036764!5m2!1sfr!2sfr" id="map" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="map"></iframe>
            </div>

            <p class="scenesSubtitle">Toï Toï</p>
            <p>13 Rue Delandine, 69002 Lyon</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2782.568279344393!2d4.875025115417774!3d45.77984167910599!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4c02047da89d9%3A0xbb734dfa74d5fc5!2zVG_DryBUb8OvIExlIFppbmM!5e0!3m2!1sfr!2sfr!4v1679047117831!5m2!1sfr!2sfr" id="map" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="map"></iframe>
            
            
            <div class="align-right-scenes">
            <p class="scenesSubtitle">Périscope</p>
            <p>6 Av. Gaston Berger, 69100 Villeurbanne</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2784.2083638745103!2d4.825416115416562!3d45.7469685791053!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4ea4ac540e4c3%3A0xeda165d393f31ca0!2sLe%20P%C3%A9riscope!5e0!3m2!1sfr!2sfr!4v1679047151766!5m2!1sfr!2sfr" id="map" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="map"></iframe>
            </div>


            <p class="scenesSubtitle">La Clef de Voûte</p>
            <p>1 Pl. Chardonnet, 69001 Lyon</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2783.016330081418!2d4.8321763154174215!3d45.77086297910578!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4eafc58c0f98f%3A0xb273103a45f0af5b!2sLa%20Clef%20de%20Vo%C3%BBte!5e0!3m2!1sfr!2sfr!4v1679047188066!5m2!1sfr!2sfr" id="map" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="map"></iframe>
            

            
            <div class="align-right-scenes">
            <p class="scenesSubtitle">Hot Club de Lyon</p>
            <p>26 Rue Lanterne, 69001 Lyon</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2783.2753376706855!2d4.8297711154172305!3d45.76567197910573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4eaffa571e001%3A0x613d56f5153b9afa!2sHot%20Club%20de%20Lyon!5e0!3m2!1sfr!2sfr!4v1679047231762!5m2!1sfr!2sfr" id="map" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="map"></iframe>
            </div>


            
            <p class="scenesSubtitle">Transbordeur</p>
            <p>3 Bd de Stalingrad, 69100 Villeurbanne</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2782.3658164636804!2d4.858259315417884!3d45.78389847910602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4ea9662b489a1%3A0xaf591eb6032d14e7!2sTransbordeur!5e0!3m2!1sfr!2sfr!4v1679047281907!5m2!1sfr!2sfr" id="map" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="map"></iframe>
            

        </div>
            
            <hr/>
    </div>
);
}

export default Scenes;